export { default } from './AlertTitle';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/lab/esm/AlertTitle/index.js
// module id = 298
// module chunks = 0